module.exports = __webpack_public_path__ + "img/eshop.8d2d2bf4.jpg";